var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61407 2.76012C10.072 4.21808 10.072 6.58189 8.61407 8.03985C7.15611 9.49781 4.79229 9.49781 3.33434 8.03985C1.87638 6.58189 1.87638 4.21808 3.33434 2.76012C4.79229 1.30216 7.15611 1.30216 8.61407 2.76012ZM10.269 8.56332C11.8105 6.47595 11.636 3.51926 9.74544 1.62875C7.66264 -0.454049 4.28576 -0.454049 2.20297 1.62875C0.12017 3.71154 0.12017 7.08842 2.20297 9.17122C4.09352 11.0618 7.0503 11.2363 9.13768 9.69471L12.951 13.508C13.2634 13.8204 13.7699 13.8204 14.0823 13.508C14.3948 13.1956 14.3948 12.6891 14.0823 12.3766L10.269 8.56332Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9a8eff2c9f471061b06002c49f7ad91c.svg";
export { ForwardRef as ReactComponent };